import React from 'react'
import PropTypes from 'prop-types'
import AlertContainer from 'react-alert'
import EditUser from './EditUser'
import { getUser, createUser, updateUser } from '../../api/users'

class EditUserContainer extends React.PureComponent {
  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'dark',
    time: 5000,
    transition: 'scale'
  }

  constructor (props, context) {
    super(props, context)

    this.state = {
      userId: this.props.match.params.userId
    }
  }

  componentDidMount () {
    if (!this.state.userId) {
      this.setState({
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        passwordConfirm: ''
      })
    } else {
      getUser(this.state.userId).then(user => {
        if (!user.firstName) {
          user.firstName = ''
        }

        if (!user.lastName) {
          user.lastName = ''
        }

        this.setState(user)
      })
    }
  }

  onChange = (event, property) => {
    const state = {}
    state[property] = event.target.value

    this.setState(state)
  }

  onSave = (event) => {
    this.saveUser().then(() => {
      // redirect to users list after creating user
      if (!this.state.userId) this.props.history.push(`/users`)
    })
  }

  onCancel = (event) => {
    this.props.history.push(`/users`)
  }

  saveUser = async () => {
    this.setState({isSaving: true})

    try {
      if (!this.state.userId) {
        return await createUser({
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          password: this.state.password,
          passwordConfirm: this.state.passwordConfirm
        }).then(() => {
          this.setState({isSaving: false})
        })
      } else {
        return await updateUser(this.state.userId, {
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          password: this.state.password,
          passwordConfirm: this.state.passwordConfirm
        }).then(() => {
          this.setState({isSaving: false})
        })
      }
    } catch (error) {
      const errorMessage = error.data ? error.data.message : 'An error occurred'
      this.msg.show(errorMessage, { type: 'error', time: 6000 })

      return Promise.reject(error)
    }
  }

  render () {
    return <div>
      <EditUser
        {...this.props}
        {...this.state}
        onChange={this.onChange}
        onSave={this.onSave}
        onCancel={this.onCancel} />
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

EditUserContainer.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
}

export default EditUserContainer



// WEBPACK FOOTER //
// ./src/pages/EditUser/EditUserContainer.js